import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';

const ExamCellExamForm = ({ onNavigate, userInfo }) => {
    // ====================================================================================================
    // STATE MANAGEMENT
    // ====================================================================================================
    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(true);

    const [activeTab, setActiveTab] = useState('pending'); // pending, approved, rejected, all, reports
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedSemester, setSelectedSemester] = useState('All');
    const [selectedCourse, setSelectedCourse] = useState('All');

    // Modal States
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedForm, setSelectedForm] = useState(null);
    const [actionComment, setActionComment] = useState('');
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmActionType, setConfirmActionType] = useState(null); // 'approve', 'reject'
    const [processingAction, setProcessingAction] = useState(false);

    // Notification State
    const [notification, setNotification] = useState(null);

    // ====================================================================================================
    // MOCK DATA
    // ====================================================================================================
    const [examForms, setExamForms] = useState([
        {
            id: 'EF-2026-001',
            studentId: 'STU001',
            studentName: 'Rahul Kumar',
            course: 'BCA',
            semester: '3rd',
            batch: '2024-2027',
            rollNo: '24BCA001',
            email: 'rahul.k@example.com',
            phone: '+91 9876543210',
            submissionDate: '2026-01-15T10:30:00',
            status: 'Pending',
            feeStatus: 'Paid',
            subjects: [
                { code: 'BCA301', name: 'Database Management Systems', type: 'Theory', credits: 4 },
                { code: 'BCA302', name: 'Java Programming', type: 'Theory', credits: 4 },
                { code: 'BCA303', name: 'Software Engineering', type: 'Theory', credits: 3 },
                { code: 'BCA304', name: 'Computer Networks', type: 'Theory', credits: 3 },
                { code: 'BCA305', name: 'DBMS Lab', type: 'Practical', credits: 2 },
                { code: 'BCA306', name: 'Java Lab', type: 'Practical', credits: 2 }
            ],
            documents: {
                photo: 'photo_url.jpg',
                signature: 'sig_url.jpg',
                paymentReceipt: 'receipt_001.pdf'
            },
            remarks: ''
        },
        {
            id: 'EF-2026-002',
            studentId: 'STU002',
            studentName: 'Priya Sharma',
            course: 'BCA',
            semester: '3rd',
            batch: '2024-2027',
            rollNo: '24BCA002',
            email: 'priya.s@example.com',
            phone: '+91 9876543211',
            submissionDate: '2026-01-15T11:45:00',
            status: 'Approved',
            feeStatus: 'Paid',
            subjects: [
                { code: 'BCA301', name: 'Database Management Systems', type: 'Theory', credits: 4 },
                { code: 'BCA302', name: 'Java Programming', type: 'Theory', credits: 4 },
                { code: 'BCA303', name: 'Software Engineering', type: 'Theory', credits: 3 },
                { code: 'BCA304', name: 'Computer Networks', type: 'Theory', credits: 3 },
                { code: 'BCA305', name: 'DBMS Lab', type: 'Practical', credits: 2 },
                { code: 'BCA306', name: 'Java Lab', type: 'Practical', credits: 2 }
            ],
            documents: {
                photo: 'photo_url.jpg',
                signature: 'sig_url.jpg',
                paymentReceipt: 'receipt_002.pdf'
            },
            remarks: 'Form verified and approved.'
        },
        {
            id: 'EF-2026-003',
            studentId: 'STU003',
            studentName: 'Amit Patel',
            course: 'MCA',
            semester: '1st',
            batch: '2025-2027',
            rollNo: '25MCA001',
            email: 'amit.p@example.com',
            phone: '+91 9876543212',
            submissionDate: '2026-01-14T14:20:00',
            status: 'Rejected',
            feeStatus: 'Pending',
            subjects: [
                { code: 'MCA101', name: 'Advanced Data Structures', type: 'Theory', credits: 4 },
                { code: 'MCA102', name: 'Advanced OS', type: 'Theory', credits: 4 },
                { code: 'MCA103', name: 'AI & ML', type: 'Theory', credits: 4 },
                { code: 'MCA104', name: 'Cloud Computing', type: 'Theory', credits: 3 },
                { code: 'MCA105', name: 'ADS Lab', type: 'Practical', credits: 2 }
            ],
            documents: {
                photo: 'photo_url.jpg',
                signature: 'sig_url.jpg',
                paymentReceipt: null
            },
            remarks: 'Fee payment receipt missing. Please pay the exam fees.'
        },
        {
            id: 'EF-2026-004',
            studentId: 'STU004',
            studentName: 'Sneha Gupta',
            course: 'BCA',
            semester: '5th',
            batch: '2023-2026',
            rollNo: '23BCA001',
            email: 'sneha.g@example.com',
            phone: '+91 9876543213',
            submissionDate: '2026-01-14T16:10:00',
            status: 'Pending',
            feeStatus: 'Paid',
            subjects: [
                { code: 'BCA501', name: 'Web Programming', type: 'Theory', credits: 4 },
                { code: 'BCA502', name: 'Python Programming', type: 'Theory', credits: 4 },
                { code: 'BCA503', name: 'Mobile Computing', type: 'Theory', credits: 3 },
                { code: 'BCA504', name: 'Elective I', type: 'Theory', credits: 3 },
                { code: 'BCA505', name: 'Web Lab', type: 'Practical', credits: 2 },
                { code: 'BCA506', name: 'Python Lab', type: 'Practical', credits: 2 }
            ],
            documents: {
                photo: 'photo_url.jpg',
                signature: 'sig_url.jpg',
                paymentReceipt: 'receipt_004.pdf'
            },
            remarks: ''
        },
        {
            id: 'EF-2026-005',
            studentId: 'STU005',
            studentName: 'Vikram Singh',
            course: 'MCA',
            semester: '3rd',
            batch: '2024-2026',
            rollNo: '24MCA001',
            email: 'vikram.s@example.com',
            phone: '+91 9876543214',
            submissionDate: '2026-01-13T09:15:00',
            status: 'Approved',
            feeStatus: 'Paid',
            subjects: [
                { code: 'MCA301', name: 'Big Data Analytics', type: 'Theory', credits: 4 },
                { code: 'MCA302', name: 'IoT', type: 'Theory', credits: 4 },
                { code: 'MCA303', name: 'Network Security', type: 'Theory', credits: 4 },
                { code: 'MCA304', name: 'Elective II', type: 'Theory', credits: 3 },
                { code: 'MCA305', name: 'Big Data Lab', type: 'Practical', credits: 2 }
            ],
            documents: {
                photo: 'photo_url.jpg',
                signature: 'sig_url.jpg',
                paymentReceipt: 'receipt_005.pdf'
            },
            remarks: 'Approved.'
        },
        // Adding more mock data to fill up the table
        ...Array.from({ length: 15 }).map((_, i) => ({
            id: `EF-2026-0${i + 6}`,
            studentId: `STU00${i + 6}`,
            studentName: `Student ${i + 6}`,
            course: i % 2 === 0 ? 'BCA' : 'MCA',
            semester: i % 2 === 0 ? '3rd' : '1st',
            batch: i % 2 === 0 ? '2024-2027' : '2025-2027',
            rollNo: i % 2 === 0 ? `24BCA0${i + 6}` : `25MCA0${i + 6}`,
            email: `student${i + 6}@example.com`,
            phone: `+91 90000000${i < 10 ? '0' + i : i}`,
            submissionDate: `2026-01-1${2 + (i % 5)}T10:00:00`,
            status: i % 3 === 0 ? 'Pending' : i % 3 === 1 ? 'Approved' : 'Rejected',
            feeStatus: i % 4 === 0 ? 'Pending' : 'Paid',
            subjects: [],
            documents: {},
            remarks: ''
        }))
    ]);

    // ====================================================================================================
    // EFFECTS
    // ====================================================================================================
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        setTimeout(() => setLoading(false), 800);
    }, []);

    // ====================================================================================================
    // HELPER FUNCTIONS
    // ====================================================================================================
    const showNotification = (message, type = 'success') => {
        setNotification({ message, type });
        setTimeout(() => setNotification(null), 3000);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Approved': return { bg: '#c6f6d5', text: '#22543d', border: '#9ae6b4' };
            case 'Rejected': return { bg: '#fed7d7', text: '#822727', border: '#feb2b2' };
            case 'Pending': return { bg: '#feebc8', text: '#744210', border: '#fbd38d' };
            default: return { bg: '#edf2f7', text: '#1a202c', border: '#e2e8f0' };
        }
    };

    // ====================================================================================================
    // ACTION HANDLERS
    // ====================================================================================================
    const handleViewForm = (form) => {
        setSelectedForm(form);
        setIsViewModalOpen(true);
        setActionComment(form.remarks || '');
    };

    const handleCloseModal = () => {
        setIsViewModalOpen(false);
        setSelectedForm(null);
        setActionComment('');
    };

    const initiateAction = (type) => {
        setConfirmActionType(type);
        setIsConfirmModalOpen(true);
    };

    const confirmAction = () => {
        if (!selectedForm || !confirmActionType) return;

        setProcessingAction(true);
        setTimeout(() => {
            const updatedForms = examForms.map(f => {
                if (f.id === selectedForm.id) {
                    return {
                        ...f,
                        status: confirmActionType === 'approve' ? 'Approved' : 'Rejected',
                        remarks: actionComment
                    };
                }
                return f;
            });

            setExamForms(updatedForms);
            setProcessingAction(false);
            setIsConfirmModalOpen(false);
            setIsViewModalOpen(false);
            showNotification(`Form ${confirmActionType === 'approve' ? 'Approved' : 'Rejected'} Successfully!`, confirmActionType === 'approve' ? 'success' : 'error');
        }, 1000);
    };

    // ====================================================================================================
    // FILTERING LOGIC
    // ====================================================================================================
    const filteredForms = examForms.filter(form => {
        const matchesSearch =
            form.studentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form.studentId.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form.rollNo.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesTab = activeTab === 'all' || activeTab === 'reports' || form.status.toLowerCase() === activeTab;
        const matchesSemester = selectedSemester === 'All' || form.semester === selectedSemester;
        const matchesCourse = selectedCourse === 'All' || form.course === selectedCourse;

        return matchesSearch && matchesTab && matchesSemester && matchesCourse;
    });

    const pendingCount = examForms.filter(f => f.status === 'Pending').length;
    const approvedCount = examForms.filter(f => f.status === 'Approved').length;
    const rejectedCount = examForms.filter(f => f.status === 'Rejected').length;

    // ====================================================================================================
    // RENDER COMPONENTS
    // ====================================================================================================

    // Detail Modal Component
    const DetailModal = () => {
        if (!selectedForm) return null;

        const statusStyle = getStatusColor(selectedForm.status);

        return (
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 1100,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '1rem', backdropFilter: 'blur(3px)'
            }}>
                <div style={{
                    background: '#ffffff', width: '100%', maxWidth: '900px',
                    borderRadius: '16px', overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                    display: 'flex', flexDirection: 'column', maxHeight: '90vh'
                }}>
                    {/* Modal Header */}
                    <div style={{
                        padding: '1.5rem', borderBottom: '1px solid #eee',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        background: '#f8f9fa'
                    }}>
                        <div>
                            <h2 style={{ margin: 0, color: '#333' }}>Exam Form Details</h2>
                            <p style={{ margin: '0.25rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                                ID: {selectedForm.id} • Submitted: {new Date(selectedForm.submissionDate).toLocaleString()}
                            </p>
                        </div>
                        <button
                            onClick={handleCloseModal}
                            style={{
                                background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666'
                            }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Modal Body */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '2rem' }}>
                        {/* Student Info Section */}
                        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 2fr', gap: '2rem', marginBottom: '2rem' }}>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{
                                    width: '150px', height: '150px', borderRadius: '12px',
                                    background: '#eee', margin: '0 auto 1rem', display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', color: '#aaa',
                                    border: '1px dashed #ccc'
                                }}>
                                    Student Photo
                                </div>
                                <h3 style={{ margin: '0 0 0.5rem 0' }}>{selectedForm.studentName}</h3>
                                <p style={{ margin: 0, color: '#666' }}>{selectedForm.studentId}</p>
                                <div style={{ marginTop: '1rem' }}>
                                    <span style={{
                                        display: 'inline-block', padding: '0.4rem 1rem', borderRadius: '20px',
                                        fontSize: '0.9rem', fontWeight: '600', width: '100%',
                                        backgroundColor: statusStyle.bg, color: statusStyle.text, border: `1px solid ${statusStyle.border}`
                                    }}>
                                        Status: {selectedForm.status}
                                    </span>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', alignContent: 'start' }}>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Course</label>
                                    <div style={{ fontWeight: '500', fontSize: '1.1rem' }}>{selectedForm.course}</div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Semester</label>
                                    <div style={{ fontWeight: '500', fontSize: '1.1rem' }}>{selectedForm.semester}</div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Roll Number</label>
                                    <div style={{ fontWeight: '500', fontSize: '1.1rem' }}>{selectedForm.rollNo}</div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Batch</label>
                                    <div style={{ fontWeight: '500', fontSize: '1.1rem' }}>{selectedForm.batch}</div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Email</label>
                                    <div style={{ fontWeight: '500', fontSize: '1.1rem' }}>{selectedForm.email}</div>
                                </div>
                                <div>
                                    <label style={{ display: 'block', color: '#666', fontSize: '0.85rem', marginBottom: '0.25rem' }}>Fees Status</label>
                                    <div style={{
                                        fontWeight: '600', fontSize: '1.1rem',
                                        color: selectedForm.feeStatus === 'Paid' ? '#28a745' : '#dc3545'
                                    }}>{selectedForm.feeStatus}</div>
                                </div>
                            </div>
                        </div>

                        {/* Subjects Section */}
                        <div style={{ marginBottom: '2rem' }}>
                            <h3 style={{ borderBottom: '2px solid #238548', paddingBottom: '0.5rem', marginBottom: '1rem', color: '#238548' }}>Registered Subjects</h3>
                            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
                                <thead style={{ background: '#f8fafc' }}>
                                    <tr>
                                        <th style={{ textAlign: 'left', padding: '1rem', color: '#4a5568', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Code</th>
                                        <th style={{ textAlign: 'left', padding: '1rem', color: '#4a5568', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Subject Name</th>
                                        <th style={{ textAlign: 'left', padding: '1rem', color: '#4a5568', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Type</th>
                                        <th style={{ textAlign: 'center', padding: '1rem', color: '#4a5568', fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>Credits</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedForm.subjects && selectedForm.subjects.length > 0 ? (
                                        selectedForm.subjects.map((sub, idx) => (
                                            <tr key={idx} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                                <td style={{ padding: '0.75rem 1rem' }}>{sub.code}</td>
                                                <td style={{ padding: '0.75rem 1rem' }}>{sub.name}</td>
                                                <td style={{ padding: '0.75rem 1rem' }}>{sub.type}</td>
                                                <td style={{ padding: '0.75rem 1rem', textAlign: 'center' }}>{sub.credits}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ padding: '1rem', textAlign: 'center', color: '#666' }}>No subjects found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Action Section */}
                        <div style={{ background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px' }}>
                            <h3 style={{ margin: '0 0 1rem 0', color: '#4a5568' }}>Review & Action</h3>
                            <div style={{ marginBottom: '1rem' }}>
                                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>Remarks / Feedback (Required for Rejection)</label>
                                <textarea
                                    value={actionComment}
                                    onChange={(e) => setActionComment(e.target.value)}
                                    placeholder="Enter your remarks here..."
                                    style={{
                                        width: '100%', minHeight: '100px', padding: '0.75rem',
                                        borderRadius: '6px', border: '1px solid #cbd5e0',
                                        fontFamily: 'inherit', resize: 'vertical'
                                    }}
                                    disabled={selectedForm.status !== 'Pending'}
                                />
                            </div>

                            {selectedForm.status === 'Pending' ? (
                                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                                    <button
                                        onClick={() => initiateAction('reject')}
                                        disabled={!actionComment.trim()}
                                        style={{
                                            padding: '0.75rem 1.5rem',
                                            borderRadius: '6px',
                                            border: '1px solid #dc3545',
                                            background: '#fff',
                                            color: '#dc3545',
                                            fontWeight: '600',
                                            cursor: actionComment.trim() ? 'pointer' : 'not-allowed',
                                            opacity: actionComment.trim() ? 1 : 0.6
                                        }}
                                    >
                                        ❌ Reject
                                    </button>
                                    <button
                                        onClick={() => initiateAction('approve')}
                                        style={{
                                            padding: '0.75rem 1.5rem',
                                            borderRadius: '6px',
                                            border: 'none',
                                            background: '#238548',
                                            color: '#fff',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            boxShadow: '0 4px 6px rgba(35, 133, 72, 0.2)'
                                        }}
                                    >
                                        ✅ Approve Form
                                    </button>
                                </div>
                            ) : (
                                <div style={{ textAlign: 'right', color: '#666', fontStyle: 'italic' }}>
                                    This form has already been processed. Status: <span style={{ fontWeight: 'bold', color: selectedForm.status === 'Approved' ? '#238548' : '#e53e3e' }}>{selectedForm.status}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Confirmation Modal
    const ConfirmModal = () => {
        if (!isConfirmModalOpen) return null;
        return (
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.7)', zIndex: 1200,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
                <div style={{
                    background: '#fff', padding: '2rem', borderRadius: '12px',
                    width: '400px', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.4)'
                }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                        {confirmActionType === 'approve' ? '✨' : '⚠️'}
                    </div>
                    <h3 style={{ margin: '0 0 1rem 0' }}>Are you sure?</h3>
                    <p style={{ color: '#666', marginBottom: '2rem' }}>
                        You are about to <strong>{confirmActionType}</strong> the exam form for <strong>{selectedForm.studentName}</strong>.
                        {confirmActionType === 'reject' && ' This will notify the student to rectify issues.'}
                    </p>
                    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                        <button
                            onClick={() => setIsConfirmModalOpen(false)}
                            style={{
                                padding: '0.75rem 1.5rem', background: '#e2e8f0', border: 'none',
                                borderRadius: '6px', color: '#4a5568', fontWeight: '600', cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={confirmAction}
                            disabled={processingAction}
                            style={{
                                padding: '0.75rem 1.5rem',
                                background: confirmActionType === 'approve' ? '#238548' : '#e53e3e',
                                border: 'none', borderRadius: '6px', color: '#fff', fontWeight: '600',
                                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem'
                            }}
                        >
                            {processingAction ? 'Processing...' : `Confirm ${confirmActionType === 'approve' ? 'Approve' : 'Reject'}`}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ====================================================================================================
    // MAIN RENDER
    // ====================================================================================================
    return (
        <Layout role="examcell" onNavigate={onNavigate} userInfo={userInfo} activePage="examcell-examform">
            {/* Header Controls */}
            <div style={{ marginBottom: '2rem' }}>
                <h2 style={{ margin: 0, fontSize: '1.8rem', color: '#2d3748' }}>Exam Forms Management</h2>
                <p style={{ margin: '0.5rem 0 0', color: '#718096' }}>Review and approve student exam applications</p>
            </div>

            {/* Stats Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
                {[
                    { label: 'Pending Reviews', value: pendingCount, color: '#f6ad55', bg: '#fffaf0', borderColor: '#ed8936' },
                    { label: 'Approved Forms', value: approvedCount, color: '#238548', bg: '#f0fff4', borderColor: '#48bb78' },
                    { label: 'Rejected Forms', value: rejectedCount, color: '#e53e3e', bg: '#fff5f5', borderColor: '#fc8181' },
                    { label: 'Total Applications', value: examForms.length, color: '#2b6cb0', bg: '#ebf4ff', borderColor: '#63b3ed' }
                ].map((stat, i) => (
                    <div key={i} style={{
                        background: '#fff', padding: '1.5rem', borderRadius: '12px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.02)', borderTop: `4px solid ${stat.borderColor}`
                    }}>
                        <p style={{ margin: '0 0 0.5rem 0', color: '#718096', fontSize: '0.9rem', fontWeight: '500' }}>{stat.label}</p>
                        <h2 style={{ margin: 0, fontSize: '2rem', color: stat.color }}>{stat.value}</h2>
                    </div>
                ))}
            </div>

            {/* Notification Toast */}
            {notification && (
                <div style={{
                    position: 'fixed', top: '160px', right: '20px', zIndex: 2000,
                    background: notification.type === 'success' ? '#238548' : '#e53e3e',
                    color: '#fff', padding: '1rem 1.5rem', borderRadius: '8px',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)', animation: 'slideLeft 0.3s ease'
                }}>
                    {notification.message}
                    <style>{`@keyframes slideLeft { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
                </div>
            )}

            {/* Filter Section */}
            <div style={{ background: '#fff', borderRadius: '12px', padding: '2rem', marginBottom: '2rem', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#4a5568' }}>Search Student</label>
                        <input
                            type="text" placeholder="Search by name, ID or roll No..."
                            value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', transition: 'border-color 0.2s',
                                boxSizing: 'border-box'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#238548'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#4a5568' }}>Semester</label>
                        <select
                            value={selectedSemester} onChange={(e) => setSelectedSemester(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', cursor: 'pointer', appearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.8rem center', backgroundSize: '1em',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="All">All Semesters</option>
                            <option value="1st">1st Semester</option>
                            <option value="3rd">3rd Semester</option>
                            <option value="5th">5th Semester</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#4a5568' }}>Course</label>
                        <select
                            value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)}
                            style={{
                                width: '100%', padding: '0.8rem', borderRadius: '8px', border: '1px solid #e2e8f0',
                                fontSize: '0.95rem', outline: 'none', cursor: 'pointer', appearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat', backgroundPosition: 'right 0.8rem center', backgroundSize: '1em',
                                boxSizing: 'border-box'
                            }}
                        >
                            <option value="All">All Courses</option>
                            <option value="BCA">BCA</option>
                            <option value="MCA">MCA</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', gap: '2rem', marginBottom: '1.5rem', borderBottom: '2px solid #e2e8f0', paddingBottom: '0' }}>
                {['pending', 'approved', 'rejected', 'all'].map(tab => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                            padding: '0.75rem 0', background: 'none', border: 'none',
                            borderBottom: activeTab === tab ? '3px solid #238548' : '3px solid transparent',
                            color: activeTab === tab ? '#238548' : '#718096', fontWeight: activeTab === tab ? '600' : '500',
                            textTransform: 'capitalize', cursor: 'pointer', transition: 'all 0.2s',
                            fontSize: '1rem', marginBottom: '-2px'
                        }}
                    >
                        {tab} <span style={{
                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            background: activeTab === tab ? '#238548' : '#cbd5e0', color: '#fff',
                            borderRadius: '12px', padding: '0.1rem 0.6rem', fontSize: '0.75rem', marginLeft: '0.5rem',
                            minWidth: '20px'
                        }}>
                            {tab === 'all' ? examForms.length :
                                tab === 'pending' ? pendingCount :
                                    tab === 'approved' ? approvedCount : rejectedCount}
                        </span>
                    </button>
                ))}
            </div>

            {/* Table Area */}
            <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                {loading ? (
                    <div style={{ padding: '3rem', textAlign: 'center', color: '#666' }}>Loading exams data...</div>
                ) : filteredForms.length > 0 ? (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ background: '#f8fafc' }}>
                                <tr>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Form ID</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Student</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Course Details</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'left', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Date</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'center', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Fee Status</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'center', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Status</th>
                                    <th style={{ padding: '1rem 1.5rem', textAlign: 'center', color: '#64748b', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredForms.map((form, idx) => {
                                    const statusColor = getStatusColor(form.status);
                                    return (
                                        <tr key={form.id} style={{ borderBottom: '1px solid #edf2f7', transition: 'background 0.2s' }}>
                                            <td style={{ padding: '1rem 1.5rem', fontWeight: '500', color: '#2d3748', fontSize: '0.9rem' }}>{form.id}</td>
                                            <td style={{ padding: '1rem 1.5rem' }}>
                                                <div style={{ fontWeight: '600', color: '#2d3748', fontSize: '0.95rem' }}>{form.studentName}</div>
                                                <div style={{ fontSize: '0.85rem', color: '#718096', marginTop: '0.25rem' }}>{form.studentId}</div>
                                            </td>
                                            <td style={{ padding: '1rem 1.5rem' }}>
                                                <div style={{ color: '#2d3748', fontSize: '0.95rem' }}>{form.course} - {form.semester}</div>
                                                <div style={{ fontSize: '0.85rem', color: '#718096', marginTop: '0.25rem' }}>Batch: {form.batch}</div>
                                            </td>
                                            <td style={{ padding: '1rem 1.5rem', color: '#4a5568', fontSize: '0.9rem' }}>{new Date(form.submissionDate).toLocaleDateString()}</td>
                                            <td style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                                <span style={{
                                                    color: form.feeStatus === 'Paid' ? '#238548' : '#e53e3e',
                                                    fontWeight: '600', fontSize: '0.85rem',
                                                    padding: '0.2rem 0.6rem', borderRadius: '4px',
                                                    background: form.feeStatus === 'Paid' ? '#f0fdf4' : '#fff5f5'
                                                }}>
                                                    {form.feeStatus}
                                                </span>
                                            </td>
                                            <td style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                                <span style={{
                                                    padding: '0.3rem 0.8rem', borderRadius: '20px', fontSize: '0.85rem',
                                                    fontWeight: '600', backgroundColor: statusColor.bg, color: statusColor.text,
                                                    border: `1px solid ${statusColor.border}`
                                                }}>
                                                    {form.status}
                                                </span>
                                            </td>
                                            <td style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                                <button
                                                    onClick={() => handleViewForm(form)}
                                                    style={{
                                                        padding: '0.5rem 1rem', background: '#edf2f7', color: '#2d3748',
                                                        border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500',
                                                        transition: 'all 0.2s', fontSize: '0.9rem'
                                                    }}
                                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; }}
                                                    onMouseLeave={(e) => { e.currentTarget.style.background = '#edf2f7'; }}
                                                >
                                                    👁️ View
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{ padding: '3rem', textAlign: 'center', color: '#666' }}>No exam forms found matching your criteria.</div>
                )}
            </div>
            {/* Modals */}
            {isViewModalOpen && <DetailModal />}
            {isConfirmModalOpen && <ConfirmModal />}
        </Layout>
    );
};

export default ExamCellExamForm;
